import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { UserState } from "../../../store/reducers/userReducer";
import { RootState } from "../../../store/index";
import LcLoading from "../../../components/Generic/LcLoading";
import { PPDropDown, PPGrid, PPDialog, PPTextField, PPUploader, PPInput } from "processor-plataform-ui";
import { CircularProgress } from "@material-ui/core";
import SideModal from "../../../components/Layout/SideModal/SideModal";
import Parse from "html-react-parser";
import { useDebounce } from "use-debounce";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { ServiceGroupSearch } from "../../../models/ServiceGroupSearch";
import { FastSolicitation } from "../../../models/FastSolicitation";
import BusinessAreaService from "../../../services/BusinessAreaService/BusinessAreaService";
import CustomerService from "../../../services/CustomerService/CustomerService";
import ServiceGroupService from "../../../services/ServiceGroupService/ServiceGroupService";
import SolicitationService from "../../../services/SolicitationService/SolicitationService";
import ProcessService from "../../../services/ProcessService/ProcessService";
import ServiceService from "../../../services/ServiceService/ServiceService";
import FastSolicitationService from "../../../services/FastSolicitationService/FastSolicitationService";
import SolicitationAttachmentService from "../../../services/SolicitationAttachmentService/SolicitationAttachmentService";

import "./index.css";
import LcIconLink from "../../../components/Generic/LcIconLink";
import { CommentType } from "../../../models/SolicitationComment";
import LcDropDown from "../../../components/Generic/LcDropDown";
import LcAccordion from "../../../components/Generic/LcAccordion";
import { PPFormHH, PPFormTemplate } from "../../../components/Layout/PPFormHH/PPFormHH";
import { MenuState } from "../../../store/reducers/menuReducer";
import { SolicitationUrgencyPortugues } from "../../../models/solicitation";
import { AlertColor } from "../../../components/Dialog/AlertNotification";
import TextTools, { Validation } from "../../../services/TextTools/TextTools";
import Modal from "../../../components/Dialog/Modal";
import HHRichTextBoxDescriptionNew from "../../../components/Form/HHRichTextBoxDescriptionNew";
import LcIcon from "../../../components/Generic/LcIcon";
import { escapeRegExp } from "lodash";
import HHDescriptionTextBox from "../../../components/Form/HHDescriptionTextBox";
import SelectDropdown from "../../../components/Generic/SelectDropdown";

interface Solicitation {
    idCustomer?: number;
    idService?: number;
    idProcess?: number;
    subject?: string;
    detailing?: string;
    idUserRequester?: number;
    IdSolicitationGroup?: number;
    nicknameUserRequester?: string;
    aditionalName?: string;
    IdUserOpening?: number;
    idUrgencia?: number;
    saveTemplate?: number;
    nameTemplate?: string;
    idUserOpenning?: number;
    SolicitationFormResponseView?: { idSolicitation: number, responses: any; };
}

interface Props {
    loading: boolean,
    show: boolean,
    handleClose: Function,
    duplicateRow: any,
    templateSelected: any,
}

const CreateNewSolicitation: React.FC<Props> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const menu = useSelector<RootState, MenuState>(state => state.menu);

    const businessAreaService = new BusinessAreaService(props);
    const customerService = new CustomerService(props);
    const serviceGroupService = new ServiceGroupService(props);
    const processService = new ProcessService(props);
    const solicitationService = new SolicitationService(props);
    const serviceService = new ServiceService(props);
    const fastSolicitationService = new FastSolicitationService(props);
    const solicitationAttachmentService = new SolicitationAttachmentService(props);
    const sideModalVsisible = useRef<any>()
    const util = new TextTools();

    let newSolicitation_: FastSolicitation = {
        idCustomer: 0,
        idService: 0,
        idProcess: 0,
        idUserRequester: 0,
        IdSolicitationGroup: 0,
        idUserOpening: 0,
        urgency: 0,
        saveTemplate: 0,
        nameTemplate: "",
        subject: "",
        detailing: "",
        nicknameUserRequester: "",
        aditionalName: "",
        id: 0,
        SolicitationFormResponseView: {}
    };

    const [newSolicitation, setNewSolicitation] = useState<FastSolicitation>(newSolicitation_);
    const [businessAreaList, setBusinessAreaList] = useState<any[]>([]);
    const [customerList, setCustomerList] = useState<any[]>([]);
    const [serviceGroupList, setServiceGroupList] = useState<any[]>([]);
    const [processList, setProcessList] = useState<any[]>([]);
    const [serviceList, setServiceList] = useState<any[]>([]);
    const [urgencyList, setUrgencyList] = useState<any[]>([]);
    const [solicitationGroupList, setSolicitationGroupList] = useState<any[]>([]);
    const [serviceListAll, setServiceListAll] = useState<any[]>([]);
    const [saveTemplate, setSaveTemplate] = useState<boolean>(false);
    const [nameTemplate, setNameTemplate] = useState<string>("");
    const [resultData, setResultData] = useState<any>({});
    const [resultDataResult, setResultDataResult] = useState<any>();
    const [error, setError] = useState<any>();
    const [refreshSeed, setRefreshSeed] = useState<number>();
    const [isloading, setIsLoading] = useState<boolean>(false);
    const [templatePPForm, setTemplatePPForm] = useState<PPFormTemplate>();
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [disabledServiceGroup, setDisableServiceGroup] = useState<boolean>(true);
    const [disabledService, setDisableService] = useState<boolean>(true);
    const [disabledProcess, setDisableProcess] = useState<boolean>(true);
    const [mobile, setMobile] = useState(window.screen.width < 600)
    const [extraFormEnabled, setExtraFormEnabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(props.loading);
    const [open, setOpen] = useState<boolean>(false);
    const [files, setFiles] = useState<any[]>([]);
    const [message, setMessage] = useState<string>("");
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [loadSave, setLoadSave] = useState<boolean>(false);
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);
    const [subject, setSubject] = useState<string>("");
    const [search = "", setSearch] = useState<string>();
    const [searchDebounce] = useDebounce(search, 300);
    const [detailing = "", setDetailing] = useState<string>();
    const [disable, setDisable] = useState<boolean>(true);
    const [disableButton, setDisableButton] = useState<boolean>(true);
    const [searchResult, setSearchResult] = useState<ServiceGroupSearch[]>([]);
    const [solicitationNumber, setSolicitationNumber] = useState<number>(0);
    const [groupSelection, setGroupSelection] = useState<boolean>(false);
    const [loadingLabel, setLoadingLabel] = useState<boolean>(true);
    const [validWordCheck, setValidWordCheck] = useState<boolean>(false);
    const [modalWordCheck, setModalWordCheck] = useState<boolean>(false);
    const [keyWWord, setkeyWord] = useState<string>("");
    const searchRef = useRef<any>(null);
    const serviceRef = useRef<any>(null);
    const [submitted, setSubmitted] = useState<boolean>(false);
    // const [canSave, setCanSave] = useState<boolean>(false);

    const selectionDefaultAux = {
        userId: Number(user.id),
        idBusinessArea: 0,
        idCustomer: 0,
        idServiceGroup: 0,
        idService: 0,
        idProcess: 0,
        idUrgency: 1,
        idSolicitationGroup: 0
    }

    const [selectionDefault, setSelectionDefault] = useState<any>(selectionDefaultAux);

    const validationsDefault: Validation[] = [
        {
            name: "subject",
            message: "Preencha um assunto válido",
            valid: true,
        },
        {
            name: "detailing",
            message: "Preencha um detalhamento válido",
            valid: true,
        },
        {
            name: "idBusinessArea",
            message: "Selecione uma área de negócio válida",
            valid: true,
        },
        {
            name: "idCustomer",
            message: "Selecione um cliente válido",
            valid: true,
        },
        {
            name: "idServiceGroup",
            message: "Selecione um grupo de serviço válido",
            valid: true,
        },
        {
            name: "idService",
            message: "Selecione um serviço válido",
            valid: true,
        },
        {
            name: "idProcess",
            message: "Selecione um processo válido",
            valid: true,
        },
        {
            name: "nameTemplate",
            message: "Preencha um nome de template válido",
            valid: true,
        },
        {
            name: "idSolicitationGroup",
            message: "Preencha um grupo de solicitação válido",
            valid: true,
        },
        {
            name: "idUrgency",
            message: "",
            valid: true,
        },
    ];

    const [validations, setValidations] = useState<Validation[]>(validationsDefault);

    useEffect(() => {
        setModalVisible(false);
    }, []);

    useEffect(() => {
        if (props.show) {
            init();

            if (!menu.showHelper) {
                if (user) initServices();
            }
            else {
                setSolicitationGroupList(mountDropGroupList([{
                    disabled: 0,
                    description: "teste"
                }]));
            }
        }

        setModalVisible(props.show);
    }, [props.show]);

    useEffect(() => {
        if (validWordCheck) handleSubmit();
    }, [validWordCheck]);

    useEffect(() => {
        if (props.show) {
            if (
                selectionDefault.idCustomer === 0 ||
                selectionDefault.idProcess === 0 ||
                selectionDefault.idService === 0 ||
                // selectionDefault.idServiceGroup === 0 || (solicitationGroupList.length > 0) ? selectionDefault.idSolicitationGroup === 0 : '' || subject === "" || detailing === "<p><br></p>" || detailing === "" || (saveTemplate && nameTemplate === "")) {
                selectionDefault.idServiceGroup === 0 ||
                (solicitationGroupList.length > 1 && (selectionDefault.idSolicitationGroup === 0 || selectionDefault.idSolicitationGroup === -1) && user.requiredSolicitationGroup === 1) ||
                subject === "" ||
                detailing === "<p><br></p>" ||
                detailing === "" ||
                (saveTemplate && nameTemplate === "") ||
                isloading
            ) {
                setDisableButton(true);
            }
            else if (!submitted) {
                setDisableButton(false);
            }
        }
    }, [selectionDefault, detailing, subject, submitted, saveTemplate, nameTemplate, isloading]);

    useEffect(() => {
        if (businessAreaList.length > 0 || customerList.length > 0 || serviceGroupList.length > 0 || serviceList.length > 0 || processList.length > 0 || urgencyList.length > 0 || solicitationGroupList.length > 0) {
            let selectionDefaultTemp = selectionDefault;

            if (businessAreaList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idBusinessArea: businessAreaList[0].value };
            }

            if (customerList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idCustomer: customerList[0].value };
            }

            if (serviceGroupList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idServiceGroup: serviceGroupList[0].value };
            }

            if (serviceList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idService: serviceList[0].value };
            }
            if (processList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idProcess: processList[0].value };
            }

            if (urgencyList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idUrgency: urgencyList[0].value };
            }

            if (selectionDefaultTemp !== selectionDefault) {
                setSelectionDefault(selectionDefaultTemp);
            }
        }
    }, [businessAreaList, customerList, serviceGroupList, serviceList, processList, urgencyList, solicitationGroupList]);

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idCustomer: 0,
                idServiceGroup: 0,
                idService: 0,
                idProcess: 0,
            });
        }

        setCustomerList([]);
        setServiceGroupList([]);
        setServiceList([]);
        setProcessList([]);
        setDisableServiceGroup(true);
        setDisableService(true);
        setDisableProcess(true);
        setTemplatePPForm(undefined);

        if (props.show) {
            if (selectionDefault.idBusinessArea !== 0) {
                getCustomerList(selectionDefault.userId, selectionDefault.idBusinessArea);
                getSolicitationGroupList(selectionDefault.idBusinessArea);
            }
        }

    }, [selectionDefault.idBusinessArea]);

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idServiceGroup: 0,
                idService: 0,
                idProcess: 0,
            });
        }

        setServiceGroupList([]);
        setServiceList([]);
        setProcessList([]);
        setDisableServiceGroup(true);
        setDisableService(true);
        setDisableProcess(true);
        setTemplatePPForm(undefined);

        if (props.show) {
            if (selectionDefault.idCustomer != 0) {
                getServiceGroupList(selectionDefault.userId, selectionDefault.idBusinessArea, selectionDefault.idCustomer);
            }
        }
    }, [selectionDefault.idCustomer]);

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idService: 0,
                idProcess: 0,
            });
        }

        // setDisableServiceGroup(true);
        setServiceList([]);
        setProcessList([]);
        setDisableService(true);
        setDisableProcess(true);
        setTemplatePPForm(undefined);

        if (props.show) {
            if (selectionDefault.idServiceGroup !== 0) {
                getServiceList(selectionDefault.userId, selectionDefault.idBusinessArea, selectionDefault.idCustomer, selectionDefault.idServiceGroup);
            }
        }
    }, [selectionDefault.idServiceGroup]);

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idProcess: 0,
            });
        }

        setProcessList([]);
        setDisableProcess(true);
        setTemplatePPForm(undefined);

        if (props.show) {
            if (selectionDefault.idService !== 0) {
                getProcessList(selectionDefault.userId, selectionDefault.idBusinessArea, selectionDefault.idCustomer, selectionDefault.idServiceGroup, selectionDefault.idService);
            }
        }
    }, [selectionDefault.idService]);

    useEffect(() => {
        if (props.show) {
            if (selectionDefault.idProcess !== 0) {
                buildExtraForm(selectionDefault.idService, selectionDefault.idProcess);
            }
        }
    }, [selectionDefault.idProcess]);

    useEffect(() => {
        setDisableButton(true);

        if (templatePPForm && templatePPForm.fields) {
            let fields = templatePPForm.fields.find((item) => {
                return resultDataResult && item.required && (resultDataResult[item.name] === "" || resultDataResult[item.name] === undefined);
            });

            if (fields || subject === "" || detailing === "" || detailing === "<p><br></p>") {
                setDisableButton(true);
            }
            else {
                setDisableButton(false);
            }
        }
    }, [resultDataResult]);

    useEffect(() => {
        if (searchDebounce !== "") searchKeyWords(searchDebounce);
        else setSearchResult([]);
    }, [searchDebounce]);

    // useEffect(() => {
    //     let validationsCount = validations.filter(x => x.valid == false);

    //     if (validationsCount.length > 0) {
    //         setCanSave(false);
    //     }
    //     else {
    //         setCanSave(true);
    //     }
    // }, [validations])

    const init = () => {
        setBusinessAreaList([]);
        setCustomerList([]);
        setServiceGroupList([]);
        setSolicitationGroupList([]);
        setServiceList([]);
        setProcessList([]);
        setUrgencyList([]);
        setSearchResult([]);
        setDisableServiceGroup(true);
        setDisableService(true);
        setDisableProcess(true);
        setSaveTemplate(false);
        setNameTemplate("");
        setOpenNotificacao(false);
        setSolicitationNumber(0);
        setSeverity("info");
        setDetailing("");
        setSubject("");
        setSelectionDefault(selectionDefaultAux);
        setMessage("");
        setFiles([]);
        setDisable(false);
        setSearch("");
        setTemplatePPForm(undefined);
        setLoading(props.loading);
        setValidations(validationsDefault);
        setGroupSelection(false);
        setDisableButton(true);
    }

    const initServices = async () => {
        setLoading(true);

        if (props.templateSelected) {
            getServiceTemplate();
        }

        try {
            await getBusinessAreaList(Number(user.id));
            setUrgencyList(mountDropListFromEnum(SolicitationUrgencyPortugues));
        }
        catch (error) {

        }

        setLoading(false);
    }

    const validateCheck = (name, value) => {
        let validationsChecks = validations;
        const valitationOnList = validations.find(x => x.name === name);

        if (valitationOnList) {
            let validationAux = {
                name: valitationOnList.name,
                message: valitationOnList.message,
                // valid: ((value.length && value.length === 0) || value === 0 || (value === -1 && user.requiredSolicitationGroup === 1)) ? false : true
                valid: (
                    (value.name === "idSolicitationGroup" && (value === 0 || value === -1) && user.requiredSolicitationGroup === 1) ||
                    (value.length && value.length === 0) ||
                    (value === 0 && value.name !== "idSolicitationGroup")
                )
                    ? false
                    : true
            };

            if (name === "nameTemplate") {
                validationAux = {
                    ...validationAux,
                    valid: (value.length > 0 || saveTemplate === false) ? true : false
                };
            }

            validationsChecks = validationsChecks.filter(x => x.name !== name);
            validationsChecks.push(validationAux);
        }

        setValidations(validationsChecks);
    }

    const buildExtraForm = async (_serviceId: number, _processId: number) => {
        setIsLoading(true);
        setTemplatePPForm(undefined);
        // setDisableButton(true);

        try {
            var response = await serviceService.getForm(_processId, false, false, _serviceId, 0);

            if (response.data) {
                setTemplatePPForm(response.data);
                setExtraFormEnabled(true);
            }
            else {
                // setDisableButton(true);
                setExtraFormEnabled(false);
            }
        }
        catch (e) {
            console.warn(e);
        }

        setIsLoading(false);
    }

    const mountDropGroupList = (list: any[]) => {
        let result = [{ label: "Nenhum", value: -1 }];

        if (list.length > 0) {
            let _list = list
                .filter(c => (c.disabled) ? c.disabled === 0 || c.disabled === false : c)
                .map(c => { return { label: c.description, value: c.id } })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 })

            return [...result, ..._list];
        }
        else {
            return result;
        }
    }

    const mountDropListFromEnum = (data: any) => {
        let result: any[] = [];

        for (let i = 0; i < Object.keys(data).length / 2; i++) {
            result.push({ label: Object.keys(data)[i + 4], value: Object.keys(data)[i] });
        }

        return result;
    }

    const getBusinessAreaList = async (userId: number) => {
        try {
            var businessResponse = await businessAreaService.getByUserId(userId);
            setBusinessAreaList(util.mountDropList(businessResponse.data));

            if (businessResponse.data.length === 1) {
                let businessAreaId_ = 1;
                if (businessResponse.data[0]) businessAreaId_ = businessResponse.data[0].id;
                await getCustomerList(userId, businessAreaId_);
            }
        }
        catch (error) {
            debugger;
        }
    };

    const getCustomerList = async (userId: number, businessAreaId: number) => {
        try {
            var customerResponse = await customerService.getByUserId(userId, businessAreaId);
            setCustomerList(util.mountDropList(customerResponse.data));

            if (customerResponse.data.length === 1) {
                let customerId_ = 1;
                if (customerResponse.data[0]) customerId_ = customerResponse.data[0].id;
                await getServiceGroupList(userId, businessAreaId, customerId_);
            }
        }
        catch (error) {
            debugger;
        }
    };

    const getServiceGroupList = async (userId: number, businessAreaId: number, customerId: number) => {
        try {
            var serviceGroupResponse = await serviceGroupService.getByUserId(userId, businessAreaId, customerId);
            setServiceGroupList(util.mountDropList(serviceGroupResponse.data));
            setDisableServiceGroup(false);

            if (serviceGroupResponse.data.length === 1) {
                let serviceGroup_ = 0;
                if (serviceGroupResponse.data[0]) serviceGroup_ = serviceGroupResponse.data[0].id;
                await getServiceList(userId, businessAreaId, customerId, serviceGroup_);
            }
        }
        catch (error) {
            debugger;
        }
    };

    const getServiceList = async (userId: number, businessAreaId: number, customerId: number, serviceGroupId: number) => {
        try {
            var serviceResponse = await serviceService.getByUserId(userId, businessAreaId, customerId, serviceGroupId);
            setServiceListAll(serviceResponse.data);
            setServiceList(util.mountDropList(serviceResponse.data));
            setDisableService(false);

            if (serviceResponse.data.length === 1) {
                let service_ = 0;
                if (serviceResponse.data[0]) service_ = serviceResponse.data[0].id;
                await getProcessList(userId, businessAreaId, customerId, serviceGroupId, service_);
            }
        }
        catch (error) {
            debugger;
        }
    };

    const getProcessList = async (userId: number, businessAreaId: number, customerId: number, serviceGroupId: number, serviceId: number) => {
        try {
            var processResponse = await processService.getByUserId(userId, businessAreaId, customerId, serviceGroupId, serviceId);
            setProcessList(util.mountDropList(processResponse.data));
            setDisableProcess(false);

            if (processResponse.data.length === 1) {
                let processId = 0;
                if (processResponse.data[0]) processId = processResponse.data[0].id;
                buildExtraForm(serviceId, processId);
            }
        }
        catch (error) {
            debugger;
        }
    };

    const getSolicitationGroupList = async (businessAreaId: number) => {
        try {
            var solicitationResponse = await solicitationService.getSolicitationGroupByUser(Number(user.id), businessAreaId);
            setSolicitationGroupList(mountDropGroupList(solicitationResponse.data));
        }
        catch (error) {
            debugger;
        }
    };

    const copyToClipbord = (solicitationNumber: number) => {
        navigator.clipboard.writeText(solicitationNumber.toString());
    };

    const handleFiles = (files_: any[]) => {
        setFiles([...files, ...files_]);
        setOpen(false);
    }

    const removeFile = (index: number) => {
        const updatedFiles = [...files];
        updatedFiles.splice(index, 1);
        setFiles(updatedFiles);
    };

    const notificationValidation = (mensagem: string, type: AlertColor) => {
        setMessage(mensagem);
        setSeverity(type);
        setOpenNotificacao(true);
    };

    const validateCheckAll = () => {
        let validationsAux: Validation[] = [];

        validations.map(validation => {
            let valueAux;

            if (validation.name === "subject") {
                valueAux = subject;
            }
            else if (validation.name === "detailing") {
                valueAux = detailing;
            }
            else if (validation.name === "nameTemplate") {
                valueAux = nameTemplate;
            }
            else if (validation.name.includes("id")) {
                valueAux = selectionDefault[validation.name];
            }

            let validationAux = {
                name: validation.name,
                message: validation.message,
                valid: ((validation.name === "idSolicitationGroup" && (valueAux === 0 || valueAux === -1) && user.requiredSolicitationGroup === 1 && solicitationGroupList.length > 1) || (valueAux.length && valueAux.length === 0) || (valueAux === 0 && validation.name !== "idSolicitationGroup")) ? false : true
            }

            if (validation.name === "nameTemplate") {
                validationAux = {
                    ...validationAux,
                    valid: (valueAux.length > 0 || saveTemplate === false) ? true : false
                }
            }

            validationsAux.push(validationAux);
        });

        setValidations(validationsAux);

        return (validationsAux.filter(x => x.valid === false).length > 0) ? false : true;
    }

    const checkDetails = (): boolean => {
        let wordsCheck = detailing.toLocaleLowerCase();

        if (wordsCheck.includes("anexo") && files.length === 0) {
            setkeyWord("ANEXO");
            return true;
        }
        else if (wordsCheck.includes("print") && files.length === 0) {
            setkeyWord("PRINT");
            return true;
        }
        else if (wordsCheck.includes("imagem") && files.length === 0) {
            setkeyWord("IMAGEM");
            return true;
        }
        else if (wordsCheck.includes("erro") && files.length === 0) {
            setkeyWord("ERRO");
            return true;
        }
        else {
            return false;
        }
    }

    const checkTextFields = () => {
        if (detailing === "" || detailing === "<p><br></p>") {
            sideModalVsisible.current.scrollTo(0, 10);
            return true;
        }
        else {
            return false;
        }
    }

    const handleSubmit = (e?: any) => {
        // setRefreshSeed(Math.random());
        setSubmitted(true);
        setDisableButton(true);

        const canSaveLocal = validateCheckAll();
        const validDatails = checkDetails();
        const checkTexts = checkTextFields();

        var block = false;

        templatePPForm && templatePPForm.fields && templatePPForm.fields.map((item) => {
            try {
                if (!(resultDataResult && resultDataResult[item.name])) {
                    item.required && notificationValidation(`${item.required.required}`, "warning");
                    if (item.required) block = true;
                }
            }
            catch (e) {

            }
        });

        if (block) {
            return;
        }
        else if (checkTexts) {
            return;
        }
        else if (!canSaveLocal) {
            return;
        }
        else if (validDatails && !validWordCheck) {
            setModalWordCheck(true);
            return;
        }
        else {
            setLoadSave(true);
            setDisable(true);
            setDisableProcess(true);
            setDisableServiceGroup(true);
            setDisableService(true);

            let newSolicitationTemp: FastSolicitation = {
                ...newSolicitation,
                idUserRequester: Number(user.id),
                idUserOpening: Number(user.id),
                aditionalName: String(user.name),
                nicknameUserRequester: user.nickName + "",
                subject: subject,
                detailing: util.cleanTagsMinusTable(detailing),
                IdSolicitationGroup: (selectionDefault.idSolicitationGroup !== -1) ? selectionDefault.idSolicitationGroup : 0,
                idService: selectionDefault.idService,
                idProcess: selectionDefault.idProcess,
                idCustomer: selectionDefault.idCustomer,
            };

            let urgency_ = 1;
            let urgencyUser = 1;
            let urgencyService = 1;

            const service = serviceListAll.find(x => x.id === selectionDefault.idService);

            if (service && service.impact) {
                urgencyService = service.impact;
            }

            if (user.urgencyPermission === 1) {
                urgencyUser = selectionDefault.idUrgency;
            }

            urgency_ = (urgencyUser > urgencyService) ? urgencyUser : urgencyService;

            newSolicitationTemp = {
                ...newSolicitationTemp,
                urgency: urgency_,
            };

            if (selectionDefault.idCustomer === 0) {
                newSolicitationTemp = {
                    ...newSolicitationTemp,
                    idCustomer: 2,
                };
            }

            if (saveTemplate === true && nameTemplate !== "") {
                newSolicitationTemp = {
                    ...newSolicitationTemp,
                    saveTemplate: 1,
                    nameTemplate: nameTemplate
                };
            }

            notificationValidation("Aguarde um instante", "info");

            if (resultDataResult) {
                newSolicitationTemp.SolicitationFormResponseView = { idSolicitation: 0, responses: resultDataResult };
            }

            setNewSolicitation(newSolicitationTemp);
            saveSolicitation(newSolicitationTemp);
        }
    };

    const saveSolicitation = async (solicitation: FastSolicitation) => {
        var fastSolicitationResponse = await fastSolicitationService.newSolicitation(solicitation as FastSolicitation);
        const solicitationNumber: number = fastSolicitationResponse.data.id;

        setSolicitationNumber(solicitationNumber);
        saveSolicitationAttachment(solicitationNumber);
        finishSolicitation(solicitationNumber);
        setValidWordCheck(false);
    };

    const saveSolicitationAttachment = async (solicitationNumber: number) => {
        for (let index = 0; index < files.length; index++) {
            try {
                await solicitationAttachmentService.sendFile(files[index], solicitationNumber, CommentType.External, Number(user.id));
            }
            catch (error) {
                debugger;
            }
        }
    };

    const finishSolicitation = (solicitationNumber: number) => {
        // props.handleClose()
        setMessage(`Chamado ${solicitationNumber} criado com sucesso`);
        setSeverity("success");
        setOpenNotificacao(true);
        setLoadSave(false);

        setTimeout(() => {
            handleClose();
        }, 3000)
    }

    const onChangeSubject = (e: any) => {
        setSubject(e.target.value);
        validateCheck("subject", e.target.value);
    }

    const onChangeDetailing = (e: any) => {
        setDetailing(e);
        validateCheck("detailing", e);
    }

    const handleOnchangeSearch = (e: any) => {
        setSearch(e.target.value);
    }

    const searchKeyWords = async (search: string) => {
        setLoadingLabel(true);

        try {
            const idCustomer_ = ((selectionDefault.idCustomer !== 0) ? selectionDefault.idCustomer : user.defaultCustomer.id);
            const serviceGroupResponse = await serviceGroupService.GetServicoViewFastServiceTreeTag(Number(user.id), search, idCustomer_);
            setSearchResult(serviceGroupResponse.data);
        }
        catch (error) {
            debugger;
        }

        setLoadingLabel(false);
    };

    const searchSelection = (result: ServiceGroupSearch) => {
        getServiceBusca(result);
    };

    const getServiceBusca = async (result: ServiceGroupSearch) => {
        setSelectionDefault({
            ...selectionDefault,
            idBusinessArea: result.id_area_negocio,
            idCustomer: result.id_departamento,
            idServiceGroup: result.id_grupo_servico,
            idService: result.id_servico,
            idProcess: result.id_processo
        });

        setGroupSelection(true);
        buildExtraForm(result.id_servico, result.id_processo);
    };

    const getServiceTemplate = async () => {
        setSubject(props.templateSelected.subject);
        setDetailing(props.templateSelected.details);

        setSelectionDefault({
            ...selectionDefault,
            idBusinessArea: Number(props.templateSelected.idBusinessArea),
            idCustomer: Number(props.templateSelected.idCustomer),
            idServiceGroup: Number(props.templateSelected.idServiceGroup),
            idService: Number(props.templateSelected.idService),
            idProcess: Number(props.templateSelected.idProcess)
        });

        setGroupSelection(true);
        buildExtraForm(props.templateSelected.idService, props.templateSelected.idProcess);
    };

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
        function Alert(props, ref,) {
            return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
        });

    const handleClose_ = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenNotificacao(false);
    };

    const handleChange = (event: any) => {
        if (event && event.target) {
            const { label, name, value } = event.target;

            setSelectionDefault({
                ...selectionDefault,
                [name]: Number(value)
            });

            validateCheck(name, value);
            setGroupSelection(false);
        }
    }

    const getNameTemplate = (e) => {
        setNameTemplate(e.target.value);
        // validateCheck("nameTemplate", e.target.value);
    }

    const SelectField = (propsSelect: any) => {
        const { label, value, options, name, required, id, placeholder } = propsSelect;

        return (
            <div className={"divOrderFieldsSolicitation"}>
                <SelectDropdown
                    required={required}
                    value={(value) ? options.find(x => x.value == value) : ""}
                    options={options}
                    name={name}
                    onChange={(event) => {
                        handleChange({ target: { name: name, value: event.value, label: event.label } } as any);
                    }}
                    title={label}
                    width={(mobile) ? "88vw" : "22vw"}
                    height={"40px !important"}
                    id={id}
                    placeholder={placeholder}
                    disabled={(options.length === 0) ? true : disable}
                    error={{
                        help: (name === "idSolicitationGroup" && (selectionDefault.idSolicitationGroup === 0 || selectionDefault.idSolicitationGroup === -1) && user.requiredSolicitationGroup === 1) && validations.find(x => name === x.name)?.message,
                        show: (name === "idSolicitationGroup" && (selectionDefault.idSolicitationGroup === 0 || selectionDefault.idSolicitationGroup === -1) && user.requiredSolicitationGroup === 1) && !validations.find(x => name === x.name)?.valid
                    }}
                />
            </div>
        )
    }

    const handleClose = () => {
        init();
        props.handleClose();
        setModalVisible(false);
    }

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    const handleModalCheck = () => {
        setModalWordCheck(false);
        setValidWordCheck(true);
    }

    const renderButtons = () => {
        return (
            <div className={"divOrderTextBox"} style={{ padding: "10px 15px" }}>
                <button
                    type="button"
                    className={"lc-button bg-info"}
                    onClick={() => handleSubmit()}
                    disabled={disableButton || disable}
                    style={{ marginRight: "20px", cursor: (disableButton || disable) ? "not-allowed" : "pointer" }}
                >
                    Abrir chamado
                </button>

                <button
                    type="button"
                    className={"lc-button bg-info"}
                    onClick={() => setOpen(true)}
                    disabled={disable}
                    style={{ cursor: (disable) ? "not-allowed" : "pointer" }}
                >
                    Anexar arquivo
                </button>
            </div>
        );
    };

    return (
        <>
            {
                (window.screen.width > 600)
                    ? <SideModal
                        header={"Novo chamado"}
                        visible={modalVisible}
                        onClose={() => handleClose()}
                        width={!menu.toggle ? "calc(100% - 260px)" : "calc(100% - 5rem)"}
                        height="calc(90vh - 100px)"
                        fixedHeader={true}
                    >
                        <div style={{ marginTop: "18px" }} />
                        <LcLoading loading={loading} label="Carregando...">
                            <form style={{ width: "95%", paddingLeft: "2rem", display: "initial", flexWrap: "nowrap" }} autoComplete="off">
                                <div className="divSearchTemplateCall" ref={searchRef}>
                                    <div className={"input-4 label2"} style={{ marginLeft: "5px" }}> Pesquisar </div>
                                    <LcDropDown
                                        element={
                                            <div style={{ width: "35rem", maxHeight: "400px", overflowX: "hidden", cursor: (disable) ? "not-allowed !important" : "default" }}>
                                                <PPTextField
                                                    placeholder={"Grupo, serviço, assunto..."}
                                                    onChange={handleOnchangeSearch}
                                                    value={search}
                                                    disabled={disable}
                                                    autoComplete="off"
                                                />
                                            </div>
                                        }
                                        width={"35rem"}
                                        maxHeight={"400px"}
                                        onEnterClose={true}
                                        trigger={"keyPress"}
                                        disabled={disable}
                                        overflow={true}
                                    >
                                        {
                                            (searchResult.length === 0 && search !== "")
                                                ? <span className="item"> {(loadingLabel) ? "Carregando..." : "Nenhum resultado encontrado..."}</span>
                                                : <div style={{ display: "flex", flexDirection: "column" }}>
                                                    {
                                                        searchResult && searchResult.slice(0, 10).map((result, index) => {
                                                            return (
                                                                <>
                                                                    <span
                                                                        key={index}
                                                                        className={"spanLabel"}
                                                                        style={{ cursor: "pointer", }}
                                                                        onClick={() => searchSelection(result)}
                                                                    >
                                                                        {
                                                                            (() => {
                                                                                let temp = result.path;

                                                                                var result_ = "";

                                                                                if (typeof temp === "string" && typeof search === "string") {
                                                                                    var searchMask = search;
                                                                                    searchMask = escapeRegExp(searchMask);
                                                                                    var regEx = new RegExp(searchMask, "ig");
                                                                                    var replaceMask = `<b>${searchMask.toUpperCase()}</b>`;

                                                                                    result_ = temp.replace(regEx, replaceMask);
                                                                                }

                                                                                return <>{Parse(result_)}</>;
                                                                            })()
                                                                        }
                                                                    </span>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </div>
                                        }
                                    </LcDropDown>
                                </div>

                                <hr />

                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                        <div className={"divOrderFieldsSolicitation"}>
                                            <div className={"input-4 label2"}> Assunto </div>
                                            <div className={"input-12"} style={{ width: "100%" }}>
                                                <PPInput
                                                    name={"subject"}
                                                    required
                                                    placeholder={"Descreva sucintamente seu assunto ou problema"}
                                                    onChange={onChangeSubject}
                                                    value={subject}
                                                    autoComplete={"off"}
                                                    disabled={disable}
                                                    error={{
                                                        help: validations.find(x => "subject" === x.name)?.message,
                                                        show: !validations.find(x => "subject" === x.name)?.valid
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className={"divOrderFieldsSolicitation"} style={{ marginTop: "8px" }} ref={sideModalVsisible}>
                                            <HHDescriptionTextBox
                                                label={"Detalhamento"}
                                                height={"120px"}
                                                placeholder={"Informe aqui os detalhes"}
                                                handleChange={onChangeDetailing}
                                                value={detailing}
                                                required={true}
                                                disabled={disable}
                                                help={validations.find(x => "detailing" === x.name)?.message}
                                                error={!validations.find(x => "detailing" === x.name)?.valid}
                                                handleFiles={handleFiles}
                                            />
                                        </div>
                                        {
                                            files.length > 0 &&
                                            <LcAccordion title={"Anexos (" + files.length + ")"} visible>
                                                <div className={"divOrderAttachmentSolicitation"}>
                                                    {
                                                        files && files.map((file, index) => {
                                                            let size = formatBytes(file.size);

                                                            return (
                                                                <div className={"divShowfile"}>
                                                                    <LcIcon
                                                                        icon={"ppi ppi-paper-clip"}
                                                                        size={"small"}
                                                                        color={"#898DA6"}
                                                                    />
                                                                    <div className="divOrderAttachmentShow">
                                                                        <span className={"spanLabel"}>{file.name}</span>
                                                                        <span className={"spanSize"}>{size}</span>
                                                                    </div>
                                                                    <LcIconLink
                                                                        icon={"ppi ppi-x"}
                                                                        tooltip={"Remover"}
                                                                        size={"small"}
                                                                        onClick={() => removeFile(index)}
                                                                        color={"red"}
                                                                        disabled={disable}
                                                                    />
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </LcAccordion>
                                        }
                                        {
                                            !extraFormEnabled &&
                                            renderButtons()
                                        }
                                    </div>

                                    <br />

                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        {
                                            businessAreaList.length >= 1 &&
                                            <SelectField
                                                required
                                                value={(businessAreaList.length > 0 || selectionDefault.idBusinessArea !== 0) ? selectionDefault.idBusinessArea : ""}
                                                options={businessAreaList}
                                                name={"idBusinessArea"}
                                                label={"Área de negócio"}
                                                id={"solicitationBusinessArea"}
                                                placeholder={`Selecione a área de negócio`}
                                            />
                                        }
                                        {
                                            <SelectField
                                                required
                                                value={(serviceList.length > 0 && selectionDefault.idServiceGroup !== 0) ? selectionDefault.idServiceGroup : ""}
                                                options={serviceGroupList}
                                                name={"idServiceGroup"}
                                                label={"Grupo de serviço"}
                                                id={"solicitationServiceGroup"}
                                                placeholder={`Selecione o grupo de serviço`}
                                            />
                                        }
                                        {
                                            <SelectField
                                                required
                                                value={(processList.length > 0 || selectionDefault.idProcess > 0) ? selectionDefault.idProcess : ""}
                                                options={processList}
                                                name={"idProcess"}
                                                label={"Processo"}
                                                id={"solicitationProcess"}
                                                placeholder={`Selecione o processo`}
                                            />
                                        }
                                        {
                                            <div style={{ display: "flex", alignItems: "center", marginLeft: "20px", width: "23.5vw", height: "50px" }}>
                                                <input
                                                    type={"checkbox"}
                                                    onChange={(e) => setSaveTemplate(e.target.checked)}
                                                    disabled={disable}
                                                    style={{ transform: "scale(1.5)" }}
                                                />
                                                <div className={"input-4 label2"} children={"Salvar template"} style={{ marginLeft: "20px", marginBottom: "0px" }} />
                                            </div>
                                        }
                                        {
                                            saveTemplate &&
                                            <div className={"divOrderFieldsSolicitation"}>
                                                <div className={"input-4 label2"} children={"Nome do template"} style={{ paddingLeft: "5px", marginBottom: "0" }} />
                                                <PPTextField
                                                    required={saveTemplate}
                                                    placeholder={"Nome do template"}
                                                    onChange={(e) => getNameTemplate(e)}
                                                    value={nameTemplate}
                                                    disabled={disable}
                                                    style={{ width: "22vw" }}
                                                    autoComplete={"off"}
                                                    help={validations.find(x => "nameTemplate" === x.name)?.message}
                                                    error={!validations.find(x => "nameTemplate" === x.name)?.valid}
                                                />
                                            </div>
                                        }
                                    </div>

                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        {
                                            businessAreaList.length >= 1 &&
                                            <SelectField
                                                required={customerList.length >= 1}
                                                value={(customerList.length > 0 || selectionDefault.idCustomer > 0) ? selectionDefault.idCustomer : ""}
                                                options={customerList}
                                                name={"idCustomer"}
                                                label={"Cliente"}
                                                id={"solicitationCustomer"}
                                                placeholder={`Selecione o cliente`}
                                            />
                                        }
                                        {
                                            <SelectField
                                                required
                                                value={(serviceList.length > 0 || selectionDefault.idService > 0) ? selectionDefault.idService : ""}
                                                options={serviceList}
                                                name={"idService"}
                                                label={"Serviço"}
                                                id={"solicitationService"}
                                                placeholder={`Selecione o serviço`}
                                            />
                                        }
                                        {
                                            solicitationGroupList.length > 1 &&
                                            <SelectField
                                                required={user.requiredSolicitationGroup === 1}
                                                value={(solicitationGroupList.length > 0 || selectionDefault.idSolicitationGroup > 0) ? selectionDefault.idSolicitationGroup : ""}
                                                options={solicitationGroupList}
                                                name={"idSolicitationGroup"}
                                                label={"Grupo de solicitante"}
                                                id={"solicitationGroup"}
                                                placeholder={`Selecione o grupo de solicitante`}
                                            />
                                        }
                                        {
                                            user.urgencyPermission !== 0 &&
                                            <SelectField
                                                value={(urgencyList.length > 0 && selectionDefault.idUrgency > 0) ? selectionDefault.idUrgency.toString() : ""}
                                                options={urgencyList}
                                                name={"idUrgency"}
                                                label={"Urgência"}
                                            />
                                        }
                                    </div>
                                </div>

                                <div style={{ display: "flex", flexDirection: "row" }}>

                                </div>

                                {
                                    isloading && <CircularProgress />
                                }
                                {
                                    !isloading && templatePPForm &&
                                    <LcAccordion title={(templatePPForm && templatePPForm.title) ? templatePPForm.title : ""} visible={true}>
                                        <PPFormHH
                                            header={""}
                                            EditForm={!disable}
                                            data={resultData}
                                            template={templatePPForm}
                                            detailButton={false}
                                            visible={!disable}
                                            enableNotifications={true}
                                            refreshSeed={refreshSeed}
                                            setResultData={(data) => setResultDataResult(data)}
                                            setError={(error) => { setError(error); }}
                                            disableFields={disable}
                                            maxWidth={"33vw"}
                                            maxWidthInternal={"32vw"}
                                            submitted={submitted}
                                        />
                                    </LcAccordion>
                                }
                                {
                                    disable &&
                                    <div style={{ marginLeft: "1vw", display: (disable) ? "flex" : "none" }} className="divOrderLoading">
                                        {
                                            loadSave &&
                                            <PPGrid container justifyContent="center" alignItems="center" className={"loadingCreate"}>
                                                <CircularProgress />
                                            </PPGrid>
                                        }
                                    </div>
                                }
                                <Modal visible={modalWordCheck} title="Abrir Chamado?" close={() => setModalWordCheck(false)}>
                                    <div className="form">
                                        <p>Você escreveu a palavra <strong>"{keyWWord}"</strong>, mas não anexou arquivos a ação. Deseja gerar o chamado mesmo assim?</p>
                                        <div className="commands">
                                            <button
                                                type="button"
                                                className="lc-button bg-info"
                                                onClick={() => handleModalCheck()}
                                            >Continuar mesmo assim </button>
                                            <button type="reset" className="lc-button bg-info" onClick={() => { setModalWordCheck(false) }}>Cancelar</button>
                                        </div>
                                    </div>
                                </Modal>

                                <Modal title={"Anexar arquivo"} visible={open} close={() => setOpen(false)}>
                                    <PPUploader
                                        onDropFile={(files: any[]) => handleFiles(files)}
                                        promptMessage={"Solte o arquivo aqui (máx. 10MB)"}
                                        maxSize={10240}
                                        largeFile={"Este componente não suporta arquivos maiores que 10Mb."}
                                    />
                                </Modal>

                                <Snackbar open={openNotificacao} anchorOrigin={{ vertical: "top", horizontal: "center" }} onClose={handleClose_}>
                                    <Alert variant="filled" severity={severity} onClose={handleClose_} style={{
                                        height: "48px",
                                        // overflow: "hidden"
                                    }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <span className={(severity != "success") ? "spanLabelNoSucess" : "spanLabelSucess"}>{message}</span>
                                            {
                                                severity === "success" &&
                                                <div style={{ marginTop: "-3px" }}>
                                                    <LcIconLink
                                                        icon={"ppi ppi-duplicate"}
                                                        size={"small"}
                                                        tooltip={"Copiar número de chamado"}
                                                        tooltipColor={"grey"}
                                                        onClick={() => copyToClipbord(solicitationNumber)}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Alert>
                                </Snackbar>

                                {
                                    menu.showHelper &&
                                    <div style={{ marginBottom: "100px" }} />
                                }
                                {
                                    extraFormEnabled &&
                                    renderButtons()
                                }
                                {
                                    menu.showHelper && <div style={{ paddingBottom: "1000px" }} />
                                }
                            </form>
                        </LcLoading>
                    </SideModal>

                    : <SideModal
                        header={"Novo chamado"}
                        visible={modalVisible}
                        onClose={() => handleClose()}
                        width={"100%"}
                        fixedHeader={true}
                    >
                        <LcLoading loading={loading} label="Carregando...">
                            <div className="iconsMobile">
                                <input
                                    type="file"
                                    id="id-file"
                                    style={{ display: "none" }}
                                    onChange={(files: any) => handleFiles(files.target.files)}
                                />
                                <label htmlFor="id-file">
                                    <LcIconLink icon={"ppi ppi-paper-clip"} />
                                </label>
                                <input
                                    type="file"
                                    id="id-image"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={(files: any) => handleFiles(files.target.files)}
                                />
                                <label htmlFor="id-image">
                                    <LcIconLink icon={"ppi ppi-photograph"} />
                                </label>

                                <LcIconLink icon={"ppi ppi-save"} onClick={(e) => setSaveTemplate(!saveTemplate)} activedAfterClick={saveTemplate} />
                            </div>

                            <form autoComplete="off">
                                <div className={"divOrderFieldsSolicitation"} style={{ width: "90vw", padding: "3px", height: "100%", marginBottom: "20px" }}>
                                    {
                                        saveTemplate &&
                                        <PPTextField
                                            required={saveTemplate}
                                            placeholder={"Nome do template"}
                                            onChange={(e) => getNameTemplate(e)}
                                            value={nameTemplate}
                                            disabled={disable}
                                            style={{ width: "90vw", marginBottom: "10px" }}
                                            autoComplete={"off"}
                                            help={validations.find(x => "nameTemplate" === x.name)?.message}
                                            error={!validations.find(x => "nameTemplate" === x.name)?.valid}
                                        />
                                    }
                                    <LcDropDown
                                        element={
                                            <div className="mobileSearch">
                                                <PPTextField
                                                    placeholder={"Pesquisar"}
                                                    onChange={handleOnchangeSearch}
                                                    value={search}
                                                    disabled={disable}
                                                    autoComplete="off"
                                                    width={"90vw"}
                                                    style={{ marginTop: "0" }}
                                                />
                                                {/* <LcIconLink icon={"ppi ppi-dots-horizontal"} onClick={(e) =>  handleOnchangeSearch(e)}  /> */}
                                            </div>
                                        }
                                        width={"90vw"}
                                        onEnterClose={true}
                                        trigger={"keyPress"}
                                        disabled={disable}
                                        overflow={true}
                                    >
                                        {
                                            (searchResult.length === 0 && search !== "")
                                                ? <span className="item"> {loadingLabel ? "Carregando..." : "Nenhum resultado encontrado..."}</span>
                                                : <div style={{ display: "flex", flexDirection: "column" }}>
                                                    {
                                                        searchResult && searchResult.slice(0, 10).map(result => {
                                                            return (
                                                                <>
                                                                    <span
                                                                        className={"spanLabel"}
                                                                        style={{ marginBottom: "10px", cursor: "pointer" }}
                                                                        onClick={() => searchSelection(result)}
                                                                    >
                                                                        {
                                                                            (() => {
                                                                                let temp = result.path;

                                                                                var result_ = "";

                                                                                if (typeof temp === "string" && typeof search === "string") {
                                                                                    var searchMask = search;
                                                                                    searchMask = escapeRegExp(searchMask);
                                                                                    var regEx = new RegExp(searchMask, "ig");
                                                                                    var replaceMask = `<b>${searchMask.toUpperCase()}</b>`;

                                                                                    result_ = temp.replace(regEx, replaceMask);
                                                                                }

                                                                                return <>{Parse(result_)}</>;
                                                                            })()
                                                                        }
                                                                    </span>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </div>
                                        }
                                    </LcDropDown>

                                    <div style={{ margin: "5px 0px" }}>
                                        <PPTextField
                                            required
                                            placeholder={"Assunto"}
                                            onChange={onChangeSubject}
                                            value={subject}
                                            autoComplete={"off"}
                                            style={{ width: "90vw", margin: "5px 0px" }}
                                            disabled={disable}
                                            help={validations.find(x => "subject" === x.name)?.message}
                                            error={!validations.find(x => "subject" === x.name)?.valid}
                                        />
                                    </div>

                                    <div style={{ margin: "5px 0px" }}>
                                        {/* <HHRichTextBoxDescriptionNew
                                            height={"80px"}
                                            placeholder={"Detalhamento"}
                                            handleChange={onChangeDetailing}
                                            required={true}
                                            disabled={disable}
                                            help={validations.find(x => "detailing" === x.name)?.message}
                                            error={!validations.find(x => "detailing" === x.name)?.valid}
                                            handleFiles={handleFiles}
                                        /> */}

                                        <HHDescriptionTextBox
                                            height={"110px"}
                                            placeholder={"Detalhamento"}
                                            handleChange={onChangeDetailing}
                                            value={detailing}
                                            required={true}
                                            disabled={disable}
                                            help={validations.find(x => "detailing" === x.name)?.message}
                                            error={!validations.find(x => "detailing" === x.name)?.valid}
                                            handleFiles={handleFiles}
                                        />
                                    </div>

                                    <div style={{ margin: "5px 0px" }}>
                                        <PPDropDown
                                            required
                                            value={(businessAreaList.length > 0 || selectionDefault.idBusinessArea !== 0) ? selectionDefault.idBusinessArea : ""}
                                            options={businessAreaList}
                                            onChange={handleChange}
                                            name={"idBusinessArea"}
                                            placeholder={"Área de negocio"}
                                            placeholderSearch={"Buscar área de negocio"}
                                            width={"90vw"}
                                        />
                                    </div>
                                    {
                                        businessAreaList.length >= 1 && customerList.length >= 1 &&
                                        <div style={{ margin: "5px 0px" }}>
                                            <PPDropDown
                                                required
                                                value={(customerList.length > 0 || selectionDefault.idCustomer !== 0) ? selectionDefault.idCustomer : ""}
                                                options={customerList}
                                                onChange={handleChange}
                                                name={"idCustomer"}
                                                placeholder={"Cliente"}
                                                placeholderSearch={"Buscar Cliente"}
                                                width={"90vw"}
                                            />
                                        </div>
                                    }
                                    {
                                        !disabledServiceGroup &&
                                        <div style={{ margin: "5px 0px" }}>
                                            <PPDropDown
                                                required
                                                value={(serviceGroupList.length > 0 || selectionDefault.idServiceGroup !== 0) ? selectionDefault.idServiceGroup : ""}
                                                options={serviceGroupList}
                                                onChange={handleChange}
                                                name={"idServiceGroup"}
                                                placeholder={"Grupo de serviço"}
                                                placeholderSearch={"Buscas grupo de serviço"}
                                                width={"90vw"}
                                            />
                                        </div>
                                    }

                                    {
                                        !disabledService &&
                                        <div style={{ margin: "5px 0px" }}>
                                            <PPDropDown
                                                required
                                                value={(serviceList.length > 0 || selectionDefault.idService !== 0) ? selectionDefault.idService : ""}
                                                options={serviceList}
                                                onChange={handleChange}
                                                name={"idService"}
                                                placeholder={"serviço"}
                                                placeholderSearch={"Buscas serviço"}
                                                width={"90vw"}
                                                disabled={disabledService}
                                            />
                                        </div>
                                    }

                                    {
                                        !disabledProcess &&
                                        <div style={{ margin: "5px 0px" }}>
                                            <PPDropDown
                                                required
                                                value={(processList.length > 0 || selectionDefault.idProcess !== 0) ? selectionDefault.idProcess : ""}
                                                options={processList}
                                                onChange={handleChange}
                                                name={"idProcess"}
                                                placeholder={"Processo"}
                                                placeholderSearch={"Buscas processo"}
                                                width={"90vw"}
                                                disabled={disabledProcess}
                                            />
                                        </div>
                                    }

                                    <div style={{ margin: "5px 0px" }}>
                                        <PPDropDown
                                            required={false}
                                            value={(solicitationGroupList.length > 0 || selectionDefault.idSolicitationGroup !== 0) ? selectionDefault.idSolicitationGroup : -1}
                                            options={solicitationGroupList}
                                            name={"idSolicitationGroup"}
                                            placeholder={"Grupo de solicitante"}
                                            placeholderSearch={"Buscas grupo de solicitante"}
                                            width={"90vw"}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div style={{ margin: "5px 0px" }}>
                                        <PPDropDown
                                            required={false}
                                            value={(urgencyList.length > 0 && selectionDefault.idUrgency > 0) ? selectionDefault.idUrgency : ""}
                                            options={urgencyList}
                                            name={"idUrgency"}
                                            onChange={handleChange}
                                            width={"90vw"}
                                            placeholder={"Urgência"}
                                            placeholderSearch={"Buscas urgência"}

                                        />
                                    </div>

                                    <Snackbar open={openNotificacao} anchorOrigin={{ vertical: "top", horizontal: "center" }} onClose={handleClose_}>
                                        <Alert variant="filled" severity={severity} onClose={handleClose_} style={{
                                            height: "60px",
                                            marginTop: "60px",
                                            alignItems: "center",
                                            padding: "20px",

                                            // overflow: "hidden"
                                        }}>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <span className={(severity != "success") ? "spanLabelNoSucess" : "spanLabelSucess"}>{message}</span>
                                                {
                                                    severity == "success" &&
                                                    <div style={{ marginTop: "-3px" }}>
                                                        <LcIconLink
                                                            icon={"ppi ppi-duplicate"}
                                                            size={"small"}
                                                            tooltip={"Copiar número de chamado"}
                                                            tooltipColor={"grey"}
                                                            onClick={() => copyToClipbord(solicitationNumber)}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </Alert>
                                    </Snackbar>

                                    {
                                        isloading &&
                                        < div style={{ marginTop: "20px" }}>
                                            <CircularProgress />
                                        </div>
                                    }
                                    {
                                        !isloading && templatePPForm &&
                                        <PPFormHH
                                            header={""}
                                            EditForm={!disable}
                                            data={resultData}
                                            template={templatePPForm}
                                            detailButton={false}
                                            visible={!disable}
                                            enableNotifications={true}
                                            refreshSeed={refreshSeed}
                                            setResultData={(data) => setResultDataResult(data)}
                                            setError={(error) => { setError(error); }}
                                            disableFields={disable}
                                            maxWidth={"95vw"}
                                            maxWidthInternal={"90vw"}
                                            submitted={submitted}
                                        />
                                    }
                                    {
                                        disable &&
                                        <div style={{ display: (disable) ? "flex" : "none", marginTop: "20px" }} className="divOrderLoading">
                                            {
                                                loadSave &&
                                                <PPGrid container justifyContent="center" alignItems="center" className={"loadingCreate"}>
                                                    <CircularProgress />
                                                </PPGrid>
                                            }
                                        </div>
                                    }

                                    {
                                        files.length > 0 &&
                                        <div className={"divOrderAttachmentSolicitation"}>
                                            {
                                                files && files.map(file => {
                                                    let size = formatBytes(file.size)
                                                    return (
                                                        <div className="divShowfile">
                                                            {/* <LcIcon
                                                        icon={"ppi ppi-paper-clip"}
                                                        size={"medium"}
                                                        color={"#898DA6"}
                                                    /> */}
                                                            <div className="divOrderAttachmentShow">
                                                                <span className={"spanLabelAnexo"}>{file.name}</span>
                                                                {/* <span className={"spanSize"}>{size}</span> */}
                                                            </div>
                                                            <LcIconLink
                                                                icon={"ppi ppi-x"}
                                                                tooltip={"Remover"}
                                                                size={"small"}
                                                                onClick={() => removeFile(file.name)}
                                                                color={"black"}
                                                                disabled={disable}
                                                            />
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    }

                                    <div className={"divOrderTextBox"}>
                                        <button
                                            type={"button"}
                                            className={"lc-button bg-info"}
                                            disabled={disableButton || disable}
                                            onClick={() => handleSubmit()}
                                        > Abrir chamado </button>
                                    </div>
                                </div>
                            </form>
                        </LcLoading>
                    </SideModal>
            }
        </>

    );
};

export default CreateNewSolicitation;